import styled from 'styled-components';
import { CloseIcon } from '../../../assets/icons/CloseIcon';
import IconButton from '../../../components/icon-button/IconButton';
import Typography from '../../../components/typography/Typography';
import { ChevronLeft } from '../../../assets/icons/ChevronLeft';
import TextField from '../../../components/text-field/TextField';

interface Props {
  headerTitle?: string;
  onBackButton?: () => void;
  onClose?: () => void;
  subHeaderComponent?: JSX.Element;
  searchTerm?: string;
  setSearchTerm?: (text: string) => void;
}

const NavigationHeader = (props: Props) => {
  const { onBackButton, headerTitle, onClose, subHeaderComponent, searchTerm, setSearchTerm } = props;

  return (
    <Header>
      <LeftContainer>
        {onBackButton && (
          <StyledIconButton onClick={onBackButton}>
            <ChevronLeft size="16px" />
          </StyledIconButton>
        )}
        <Column>
          <Typography textAlign="left" fontWeight="bold" variant="h4" onClick={onBackButton}>
            {headerTitle}
          </Typography>
          {subHeaderComponent}
        </Column>
      </LeftContainer>
      <RightContainer>
        {onClose && (
          <div style={{ display: 'flex' }}>
            <SearchFieldContainer>
              {setSearchTerm && searchTerm !== undefined && (
                <TextField fullWidth value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} label="Søg.." />
              )}
            </SearchFieldContainer>
            <StyledIconButton variant="outlined" onClick={onClose}>
              <CloseIcon size="18px" />
            </StyledIconButton>
          </div>
        )}
      </RightContainer>
    </Header>
  );
};

const StyledIconButton = styled(IconButton)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const RightContainer = styled.div`
  margin-right: ${(props) => props.theme.spacing(8)};
`;

const LeftContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${(props) => props.theme.spacing(8)};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: white;
  border-radius: ${(props) => props.theme.spacing(3)} ${(props) => props.theme.spacing(3)} 0px 0px;
  border-bottom: 1px solid ${(props) => props.theme.palette.grey.black10};
  height: 40px;
  width: 100%;
  padding: ${(props) => props.theme.spacing(5)} 0px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const SearchFieldContainer = styled.div`
  width: 300px;
  margin-right: 20px;
`;

export default NavigationHeader;
